import type {z} from "zod";

import {AddMaterialDescriptionBody} from "@project/sdk/engineering/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {materialDescriptionFieldLabelIds} from "../../../../../messages/material-description.messages";

const fields = AddMaterialDescriptionBody.shape;
export const addMaterialDescriptionFormSchema = zod.object({
  language: fields.language,
  text: requiredStringSchema(fields.text, materialDescriptionFieldLabelIds.text),
});
export type AddMaterialDescriptionFormPayload = z.output<typeof addMaterialDescriptionFormSchema>;

export const draftAddMaterialDescriptionFormSchema = addMaterialDescriptionFormSchema.partial();
export type DraftAddMaterialDescriptionFormPayload = z.output<
  typeof draftAddMaterialDescriptionFormSchema
>;
